import "stylesheets/views/intranet/IntranetHeader.css";
import React from "react";
import formatters from "util/formatters";
import classNames from "classnames";
import { observer } from "mobx-react";
import Propulator from "higher-order/Propulator";
import { URLS } from "util/constants";
import environmentUtilities from "util/environmentUtilities";
import toUpper from "lodash/toUpper";
import moment from "moment";

@observer
class IntranetHeader extends React.Component {
    render() {
        const {
            session
        } = this.props;

        const environmentName = toUpper(session?.environmentName ?? "");
        const user = session?.user;
        const isProd = environmentUtilities.isProdIntra(session);
        let currentUtc = session?.currentUtc ?? moment.utc();

        const envClasses = {
            environment: true,
            prod: isProd
        };
        const headerClasses = {
            "intranet-header": true,
            "prod-header": isProd
        };

        const roleString = (() => {
            if (this.props.hasOpsAdminRole) {
                return "ADMIN";
            }
            return "USER";
        })();
        const roleClasses = {
            role: true,
            admin: this.props.hasOpsAdminRole
        };
        return (
            <div>
                <header className={classNames(headerClasses)}>
                    <span className="title"><a href={URLS.HOME}>gradifi</a></span>
                    <div className="status">
                        <span className={classNames(roleClasses)}>
                            {roleString}
                        </span>
                        {environmentName &&
                            <span className={classNames(envClasses)}>
                                {environmentName}
                            </span>
                        }
                        {user && user.email &&
                            <span className="user">
                                Logged in as: <strong>{user.email}</strong>
                                <div className="current-date">
                                    {formatters.localDateTimeWithUtcTitle(currentUtc)}
                                </div>
                            </span>
                        }
                    </div>
                </header>
            </div>
        );
    }
}

export default Propulator(IntranetHeader, {
    sessionStore: ["session"],
    roleStore: ["hasOpsAdminRole"]
});
